import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { AddForwardDialogComponent } from './add-forward-dialog.component'

@Injectable()
export class AddForwardDialogService {
  constructor(private dialog: MatDialog) {}

  open() {
    const defaultConfig: MatDialogConfig = {
      width: '500px',
      height: 'auto',
      panelClass: ['fixed-modal'],
    }

    return this.dialog.open(AddForwardDialogComponent, defaultConfig)
  }
}
